const SESSION_ID_KEY = "clarins_crm_line_liff_session_id";
const LINE_CHANNEL_ID_KEY = "clarins_crm_line_liff_channel_id";

const getCurrentPath = () => {
  if (typeof window === "undefined") return "";

  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};

const getSearchParam = (search, key) => {
  if (!search) return null;

  const params = new URLSearchParams(search.startsWith("?") ? search : `?${search}`);
  return params.get(key);
};

const getLineChannelId = ({ includeStored = true } = {}) => {
  if (typeof window === "undefined") return null;

  const channelId =
    getSearchParam(window.location.search, "channel_id") ||
    getSearchParam(window.location.search, "channelid");
  if (channelId) {
    window.sessionStorage?.setItem(LINE_CHANNEL_ID_KEY, channelId);
    return channelId;
  }

  const liffState = getSearchParam(window.location.search, "liff.state");
  const liffChannelId =
    getSearchParam(liffState, "channel_id") ||
    getSearchParam(liffState, "channelid");
  if (liffChannelId) {
    window.sessionStorage?.setItem(LINE_CHANNEL_ID_KEY, liffChannelId);
    return liffChannelId;
  }

  if (!includeStored) return null;

  return window.sessionStorage?.getItem(LINE_CHANNEL_ID_KEY) || null;
};

const createSessionId = () => {
  if (
    typeof window !== "undefined" &&
    window.crypto &&
    window.crypto.getRandomValues
  ) {
    const randomValues = window.crypto.getRandomValues(new Uint32Array(4));
    return Array.from(randomValues, value => value.toString(16)).join("-");
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const getSessionId = () => {
  if (typeof window === "undefined" || !window.sessionStorage) return "";

  let sessionId = window.sessionStorage.getItem(SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = createSessionId();
    window.sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  return sessionId;
};

const attachTrackingHeaders = config => {
  config.headers = config.headers || {};
  config.headers["X-Current-Path"] = getCurrentPath();
  config.headers["X-Session-Id"] = getSessionId();
  attachLineChannelIdHeader(config);

  return config;
};

const attachLineChannelIdHeader = config => {
  const channelId = getLineChannelId();
  if (!channelId) return config;

  config.headers = config.headers || {};
  config.headers["line-channel-id"] = channelId;

  return config;
};

export {
  attachLineChannelIdHeader,
  attachTrackingHeaders,
  getCurrentPath,
  getLineChannelId,
  getSessionId
};
